import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';
import { InquiryOutcomeSchema, InquirySourceSchema } from '../deal/inquiries.schemas';

// Ids and machine codes only (ADR 0015 §PII): the sender's name, e-mail, phone and message stay in immo_deal.inquiries.
export const InquiryReceivedPayloadSchema = z.object({
  inquiryId: z.uuid(),
  workspaceId: z.uuid(),
  organizationId: z.uuid(),
  propertyId: z.uuid(),
  contactId: z.uuid(),
  // The Kontakt's own Standort — another than organizationId when a Kontakt of another Standort was matched.
  contactOrganizationId: z.uuid(),
  // Set for PROSPECT_CREATED and ATTACHED_TO_ACTIVE_PROSPECT, null otherwise.
  prospectId: z.uuid().nullable(),
  source: InquirySourceSchema,
  outcome: InquiryOutcomeSchema,
  // True only for PROSPECT_CREATED when the Owner became Verantwortlicher as the fallback.
  viaOwnerFallback: z.boolean(),
  actor: ActorSchema,
  receivedAt: z.iso.datetime(),
});

export type InquiryReceivedPayload = z.infer<typeof InquiryReceivedPayloadSchema>;
